import { Button, Dropdown, Icon, Menu, Modal, Popover, Table } from "antd";
import * as React from "react";
import { hasFeature } from "../../../../Actions/UserActions";
import { getTranslation } from "../../../../Actions/VerbiageActions";
import { AppArea } from "../../../../Enums/AppArea";
import { UserLoginStatus } from "../../../../Enums/Enums";
import { ScoutFeature } from "../../../../Enums/ScoutFeature";
import { IStore, ITerritory, IUser } from "../../../../Models/Models";
import ItemMap from "./ItemMap";

interface IUserManagementProps {
  user: IUser;
  allUsers: Array<IUser>;
  userFranchiseeStores: Array<IStore>;
  userFranchiseeTerritories: Array<ITerritory>;

  getUserFranchiseeTerritoryInformation: (userID: number) => void;
  getUserFranchiseeStoreInformation: (userID: number) => void;
  removeStoreFromFranchiseeUser: (userID: number, storeID: number) => void;
  removeTerritoryFromFranchiseeUser: (
    userID: number,
    territoryID: number
  ) => void;
  updateUserActiveStatus: (userID: number, activeStatus: boolean) => void;
}

interface IUserManagementState {
  allUsers: Array<IUser>;
  userManagementModalVisible: boolean;
  userManagementItemMapModalVisible: boolean;
  areYouSureVisible: boolean;
  modalSection: IUserManagementModalSection;
  selectedUser: IUser | null;
  selectedStore: IStore | null;
  selectedTerritory: ITerritory | null;
  loadingUserManagementTable: boolean;
}

enum IUserManagementModalSection {
  STORES,
  TERRITORIES,
}

interface IUserCopy extends IUser {
  // for Ant Design table
  userType: string;
  loginStatusString: string;
  showingActiveStatusMenu: boolean;
}

class UserManagement extends React.Component<
  IUserManagementProps,
  IUserManagementState
> {
  public wordStore: string = getTranslation(
      this.props.user.company.companyType,
      AppArea.LOCATIONS,
      false
  );
  public wordStores: string = getTranslation(
      this.props.user.company.companyType,
      AppArea.LOCATIONS,
      true
  );
  public wordTerritory: string = getTranslation(
      this.props.user.company.companyType,
      AppArea.TERRITORIES,
      false
  );
  public wordTerritories: string = getTranslation(
      this.props.user.company.companyType,
      AppArea.TERRITORIES,
      true
  );

  // get all user names
  private nameFilters = this.props.allUsers.map((user: IUser, index): {
    text: string;
    value: string;
  } => {
      return {
          text: user.fullName,
          value: user.fullName,
      };
  });
  // get all user login statuses - ["Active", "Idle", "Idle", "Inactive"]
  private userLoginStatuses = this.props.allUsers.map(
      (user: IUserCopy, index: number): string => {
          switch (user.loginStatus) {
              case UserLoginStatus.ACTIVE:
                  user.loginStatusString = "Active";
                  break;
              case UserLoginStatus.IDLE:
                  user.loginStatusString = "Idle";
                  break;
              case UserLoginStatus.NOT_LOGGED_IN:
                  user.loginStatusString = "Inactive";
                  break;
          }
          return user.loginStatusString;
      }
  );
  // for ant design
  private userActiveStatusMenus = this.props.allUsers.map(
      (user: IUserCopy, index: number): IUser => {
          user.showingActiveStatusMenu = false;
          return user;
      }
  );
  // get unique user login statuses - ["Active", Idle", "Inactive"]
  private uniqueUserLoginStatuses = [...new Set(this.userLoginStatuses)]; // ts yells...but it works and it compiles
  // create object for Ant-Design Filtering
  private uniqueUserLoginStatusFilters = this.uniqueUserLoginStatuses.map(
      (type: string, index: number) => {
          return {
              text: type,
              value: type,
          };
      }
  );
  private readonly userManagementUserStoreColumns: any[] = [
      {
          title: `${this.wordStore} Name`,
          dataIndex: "name", // what will show up in the UI
          // filters: this.nameFilters,// must be array of objects
          // filterMultiple: false,
          // specify the condition of filtering result
          // here is that finding the name started with `value`
          sorter: (a, b) =>
              a.name && b.name && a.name.toLowerCase() < b.name.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title: `${this.wordStore} Number`,
          dataIndex: "storeNumber", // what will show up in the UI
          defaultSortOrder: "descend",
          sorter: (a, b) =>
              a.storeNumber
        && b.storeNumber
        && a.storeNumber.toLowerCase() < b.storeNumber.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title: "City",
          dataIndex: "address.city", // what will show up in the UI
          sorter: (a, b) =>
              a.address
        && b.address
        && a.address.city
        && b.address.city
        && a.address.city.toLowerCase() < b.address.city.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title: "State",
          dataIndex: "address.state", // what will show up in the UI
          sorter: (a, b) =>
              a.address
        && b.address
        && a.address.state
        && b.address.date
        && a.address.state.toLowerCase() < b.address.state.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title: "Zip Code",
          dataIndex: "address.zip", // what will show up in the UI
          sorter: (a, b) =>
              a.address
        && b.address
        && a.address.zip
        && b.address.zip
        && a.address.zip.toLowerCase() < b.address.zip.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title: null,
          dataIndex: null,
          render: (store: IStore) => (
              <div className="manage-area">
                  <Button
                      type="danger"
                      size="small"
                      style={{ marginRight: "1rem" }}
                      onClick={(): void => this.confirmFranchiseeUserStoreUnassign(store)}
                  >
            Unassign
                  </Button>

                  <Popover
                      content={this.getItemMap(store)}
                      title={store.name || "Location"}
                      trigger="hover"
                  >
                      <Button
                          type="primary"
                          size="small"
                          shape="circle"
                          icon="eye"
                          // onClick={(): void => this.viewUserAssignedStore(store)}
                      ></Button>
                  </Popover>
              </div>
          ),
      },
  ];
  private readonly userManagementUserTerritoryColumns: any[] = [
      {
          title:
        getTranslation(
            this.props.user.company.companyType,
            AppArea.TERRITORIES,
            false
        ) + " Name",
          dataIndex: "name", // what will show up in the UI
          // filters: this.nameFilters,// must be array of objects
          // filterMultiple: false,
          // specify the condition of filtering result
          // here is that finding the name started with `value`
          defaultSortOrder: "ascend",
          sorter: (a: ITerritory, b: ITerritory) =>
              a.name && b.name && a.name.toLowerCase() < b.name.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title:
        getTranslation(
            this.props.user.company.companyType,
            AppArea.TERRITORIES,
            false
        ) + " Type",
          dataIndex: "territoryType.name", // what will show up in the UI
          sorter: (a: ITerritory, b: ITerritory) =>
              a.type && b.type && a.type.toLowerCase() < b.type.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title: "Display Label",
          dataIndex: "displayLabel", // what will show up in the UI
          sorter: (a: ITerritory, b: ITerritory) =>
              a.displayLabel
        && b.displayLabel
        && a.displayLabel.toLowerCase() < b.displayLabel.toLowerCase()
                  ? -1
                  : 1,
      },
      {
          title: "Date Created",
          dataIndex: "createdDateTimeFriendly", // what will show up in the UI
          sorter: (a: ITerritory, b: ITerritory) =>
              a.createdDateTimeFriendly
        && b.createdDateTimeFriendly
        && a.createdDateTimeFriendly < b.createdDateTimeFriendly
                  ? -1
                  : 1,
      },
      {
          title: null,
          dataIndex: null,
          render: (territory: ITerritory) => (
              <div className="manage-area">
                  <Button
                      type="danger"
                      size="small"
                      style={{ marginRight: "1rem" }}
                      onClick={(): void =>
                          this.confirmFranchiseeUserTerritoryUnassign(territory)
                      }
                  >
            Unassign
                  </Button>

                  <Popover
                      content={this.getItemMap(territory)}
                      title={
                          territory.name
              || getTranslation(
                  this.props.user.company.companyType,
                  AppArea.TERRITORIES,
                  false
              )
                      }
                      trigger="hover"
                  >
                      <Button
                          type="primary"
                          size="small"
                          shape="circle"
                          icon="eye"
                          // onClick={(): void => this.viewUserAssignedTerritory(territory)}
                      ></Button>
                  </Popover>
              </div>
          ),
      },
  ];

  /**
   *
   */
  constructor(props) {
      super(props);

      this.state = {
          allUsers: [...this.props.allUsers],
          areYouSureVisible: false,
          userManagementModalVisible: false,
          userManagementItemMapModalVisible: false,
          modalSection: IUserManagementModalSection.STORES,
          selectedUser: null,
          selectedStore: null,
          selectedTerritory: null,
          loadingUserManagementTable: false,
      };
  }

  public componentWillReceiveProps() {
      if (this.state.loadingUserManagementTable) {
          this.setState({
              loadingUserManagementTable: false,
          });
      }
      // otherwise the data table will not update (it's data comes from state)
      if (this.props.allUsers) {
          this.setState({
              allUsers: this.props.allUsers,
          });
      }
  }

  public render() {
      // get all user types - ["Admin", "Admin", "Standard", "Franchisee"]
      const userTypes = this.props.allUsers.map(
          (user: IUserCopy, index): string => {
              if (user.isAdmin) {
                  user.userType = "Admin";
              } else if (user.isFranchisee) {
                  user.userType = "Franchisee";
              } else {
                  user.userType = "Standard";
              }
              return user.userType;
          }
      );
      // get unique user types - ["Admin", Standard", "Franchisee"]
      const uniqueUserTypes = [...new Set(userTypes)]; // ts yells...but it works and it compiles
      // create object for Ant-Design Filtering
      const uniqueUserTypeFilters = uniqueUserTypes.map(
          (type: string, index: number) => {
              return {
                  text: type,
                  value: type,
              };
          }
      );
      

      const userManagementColumns: any[] = [
          {
              title: "Name",
              dataIndex: "fullName",
              sorter: (a: IUser, b: IUser) =>
                  a.fullName
            && b.fullName
            && a.fullName.toLowerCase() < b.fullName.toLowerCase()
                      ? -1
                      : 1,
          },
          {
              title: "Title",
              dataIndex: "title",
              sorter: (a: IUser, b: IUser) =>
                  a.title && b.title && a.title.toLowerCase() < b.title.toLowerCase()
                      ? -1
                      : 1
          },
          {
              title: "User Type",
              dataIndex: "userType",
              filters: uniqueUserTypeFilters,
              filterMultiple: true,
              defaultSortOrder: "ascend",
              onFilter: (value, record) => record.userType.indexOf(value) === 0,
              sorter: (a: IUserCopy, b: IUserCopy) =>
                  a.userType
            && b.userType
            && a.userType.toLowerCase() < b.userType.toLowerCase()
                      ? -1
                      : 1,
          },
          hasFeature(this.props.user, ScoutFeature.Scout4)
              ? {
                  title: `# of ${this.wordStores}`,
                  dataIndex: "franchiseStoresCount",
                  sorter: (a: IUser, b: IUser) =>
                      a.franchiseStoresCount - b.franchiseStoresCount,
              } : {},
          hasFeature(this.props.user, ScoutFeature.Scout4)
              ? {
                  title: `# of ${this.wordTerritories}`,
                  dataIndex: "franchiseTerritoriesCount",
                  sorter: (a: IUser, b: IUser) =>
                      a.franchiseTerritoriesCount - b.franchiseTerritoriesCount,
              } : {},
          {
              title: "Status",
              dataIndex: null,
              sorter: (a: IUser, b: IUser) =>
                  a.isActive === b.isActive ? 0 : a.isActive ? -1 : 1,
              render: (user: IUserCopy): JSX.Element => (
                  <div className="manage-area">
                      <div
                          className={this.getUserLoginStatusColor(user)}
                          style={{ marginRight: "1rem" }}
                      ></div>
                      <div style={{ margin: "0 1rem" }}>
                          {user.isActive ? "Active" : "Inactive"}
                      </div>
                      <Dropdown
                          overlay={this.getUserActionsMenu(user)}
                          trigger={["click"]} // override default of hover
                      >
                          <Icon type="down" style={{ cursor: "pointer" }} />
                      </Dropdown>
                  </div>
              ),
          },
          {
              title: null,
              dataIndex: null,
              render: (user: IUser): JSX.Element | null =>
                  user.isFranchisee && hasFeature(this.props.user, ScoutFeature.Scout4)? (
                      <div className="manage-area">
                          <button
                              className="manage-button right"
                              onClick={(): void => this.manageUser(user)}
                          >
                  Manage
                          </button>
                          <div className="clear"></div>
                      </div>
                  ) : null,
          },
      ];
                                    

      let modalColumns = null;
      let modalData = [];

      if (this.state.modalSection === IUserManagementModalSection.STORES) {
          modalColumns = this.userManagementUserStoreColumns;
          modalData = this.props.userFranchiseeStores;
      } else if (
          this.state.modalSection === IUserManagementModalSection.TERRITORIES
      ) {
          modalColumns = this.userManagementUserTerritoryColumns;
          modalData = this.props.userFranchiseeTerritories;
      }

      let userModal: JSX.Element | null = null;
      let areYouSureModal: JSX.Element | null = null;
      let modalEmptyVerbiage = "";
      let modalEmptyIcon: JSX.Element = null;
      if (this.state.modalSection === IUserManagementModalSection.STORES) {
          modalEmptyVerbiage = "Locations";
          modalEmptyIcon = (
              <div className="empty-icon empty-icon-dashboard-usermanagement-stores"></div>
          );
      } else if (
          this.state.modalSection === IUserManagementModalSection.TERRITORIES
      ) {
          modalEmptyVerbiage = this.wordTerritories;
          modalEmptyIcon = (
              <div className="empty-icon empty-icon-dashboard-usermanagement-territories"></div>
          );
      }

      if (this.state.selectedUser) {
          userModal = (
              <Modal
                  title={this.state.selectedUser.fullName}
                  width={1083}
                  visible={this.state.userManagementModalVisible}
                  onOk={this.handleModalOkClick}
                  onCancel={this.handleModalCancelClick}
                  footer={null}
              >
                  <div style={{ marginBottom: "1rem" }}>
                      <ul className="UserManagement-modal-tabs">
                          <li
                              className={
                                  this.state.modalSection === IUserManagementModalSection.STORES
                                      ? "tab active"
                                      : "tab"
                              }
                              onClick={(): void =>
                                  this.setUserManagementModalSection(
                                      IUserManagementModalSection.STORES
                                  )
                              }
                          >
                              {this.wordStores}
                          </li>
                          <li
                              className={
                                  this.state.modalSection
                  === IUserManagementModalSection.TERRITORIES
                                      ? "tab active"
                                      : "tab"
                              }
                              onClick={(): void =>
                                  this.setUserManagementModalSection(
                                      IUserManagementModalSection.TERRITORIES
                                  )
                              }
                          >
                              {this.wordTerritories}
                          </li>
                      </ul>
                  </div>
                  <Table
                      columns={modalColumns}
                      dataSource={modalData}
                      locale={{
                          emptyText: (
                              <div
                                  style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      padding: "0 0 4rem 0",
                                  }}
                              >
                                  {modalEmptyIcon}
                                  <h4>No {modalEmptyVerbiage}</h4>
                                  <p>
                    This user does not have any assigned{" "}
                                      {modalEmptyVerbiage.toLowerCase()}.
                                  </p>
                              </div>
                          ),
                      }}
                      onChange={this.filterChange}
                      rowKey={(item: IStore | ITerritory): string => item.id.toString()}
                  ></Table>
              </Modal>
          );
      }

      let userManagementMapItemModal: JSX.Element | null = null;
      if (this.state.userManagementItemMapModalVisible) {
          let mapItem: IStore | ITerritory = null;

          switch (this.state.modalSection) {
              case IUserManagementModalSection.STORES:
                  mapItem = this.state.selectedStore;
                  break;
              case IUserManagementModalSection.TERRITORIES:
                  mapItem = this.state.selectedTerritory;
                  break;
          }
          userManagementMapItemModal = (
              <Modal
                  title={mapItem.name}
                  visible={this.state.userManagementItemMapModalVisible}
                  onOk={this.handleUserManagementMapItemModalOkClick}
                  onCancel={this.handleUserManagementMapItemModalCancelClick}
              >
                  <ItemMap
                      containerElement={<div style={{ height: "157px" }}></div>}
                      mapElement={<div style={{ height: "100%" }}></div>}
                      item={mapItem}
                  ></ItemMap>
              </Modal>
          );
      }

      switch (this.state.modalSection) {
          case IUserManagementModalSection.STORES:
              if (this.state.selectedStore && this.state.selectedUser) {
                  areYouSureModal = (
                      <Modal
                          title={`Unassign ${this.wordStore}?`}
                          visible={this.state.areYouSureVisible}
                          onOk={this.handleAreYouSureOk}
                          onCancel={this.handleAreYouSureCancel}
                      >
                          <p>
                Are you sure you want to unassign{" "}
                              {this.state.selectedStore.name} from{" "}
                              {this.state.selectedUser.fullName}?
                          </p>
                      </Modal>
                  );
              }
              break;

          case IUserManagementModalSection.TERRITORIES:
              if (this.state.selectedTerritory && this.state.selectedUser) {
                  areYouSureModal = (
                      <Modal
                          title={`Unassign ${this.wordTerritory}}?`}
                          visible={this.state.areYouSureVisible}
                          onOk={this.handleAreYouSureOk}
                          onCancel={this.handleAreYouSureCancel}
                      >
                          <p>
                Are you sure you want to unassign{" "}
                              {this.state.selectedTerritory.name} from{" "}
                              {this.state.selectedUser.fullName}?
                          </p>
                      </Modal>
                  );
              }
              break;
      }

      return (
          <div className="UserManagement">
              {userModal}
              {areYouSureModal}
              {userManagementMapItemModal}

              <div className="top-container">
                  <h2 className="settings-title">Users</h2>
                  <input
                      id="user-management-search"
                      type="search"
                      placeholder="Search for user..."
                      onChange={this.userSearchInputChanged}
                  />
              </div>

              <Table
                  columns={userManagementColumns}
                  dataSource={this.state.allUsers}
                  onChange={this.filterChange}
                  loading={this.state.loadingUserManagementTable}
                  rowKey={(user: IUser): string => user.userID.toString()}
              ></Table>
          </div>
      );
  }

  private getItemMap = (itemRequested): JSX.Element => {
      // itemRequested must be either a store or territory
      return (
          <ItemMap
              containerElement={<div style={{ height: "157px" }}></div>}
              mapElement={<div style={{ height: "100%" }}></div>}
              item={itemRequested}
          ></ItemMap>
      );
  };

  private setUserManagementTableLoading = (loading: boolean) => {
      this.setState({
          loadingUserManagementTable: loading,
      });
  };

  private updateUserActiveStatus = (user: IUser): void => {
      this.setUserManagementTableLoading(true);
      this.props.updateUserActiveStatus(user.userID, !user.isActive);
  };

  private getUserActionsMenu = (user: IUserCopy): JSX.Element => {
      const menu = (
          <Menu onClick={(): void => this.updateUserActiveStatus(user)}>
              <Menu.Item>
                  {user.isActive ? "Deactivate User" : "Activate User"}
              </Menu.Item>
          </Menu>
      );

      return menu;
  };

  private getUserLoginStatusColor = (user: IUser): string => {
      switch (user.loginStatus) {
          case UserLoginStatus.ACTIVE:
              return "circle green";
          case UserLoginStatus.IDLE:
          case UserLoginStatus.NOT_LOGGED_IN:
              return "circle grey";
      }
  };

  private manageUser = (user: IUser): void => {
      this.setSelectedUser(user);
      this.openUserManagementModal();
      this.props.getUserFranchiseeStoreInformation(user.userID);
      this.props.getUserFranchiseeTerritoryInformation(user.userID);
  };

  private viewUserAssignedTerritory = (territory: ITerritory): void => {
      this.setSelectedTerritory(territory);
      this.setUserManagementMapItemModalVisiblity(true);
  };

  private viewUserAssignedStore = (store: IStore): void => {
      this.setSelectedStore(store);
      this.setUserManagementMapItemModalVisiblity(true);
  };

  private setSelectedUser = (user: IUser | null): void => {
      this.setState({
          selectedUser: user,
      });
  };

  private openUserManagementModal = (): void => {
      this.setUserManagementModalVisiblity(true);
      this.setUserManagementModalSection(IUserManagementModalSection.STORES);
  };

  private setUserManagementModalSection = (
      section: IUserManagementModalSection
  ): void => {
      this.setState({
          modalSection: section,
      });
  };

  private handleModalCancelClick = (): void => {
      this.setUserManagementModalVisiblity(false);
  };
  private handleModalOkClick = (): void => {
      this.setUserManagementModalVisiblity(false);
  };
  private handleAreYouSureCancel = (): void => {
      this.setAreYouSureVisibility(false);
  };
  private handleAreYouSureOk = (): void => {
      switch (this.state.modalSection) {
          case IUserManagementModalSection.STORES:
              this.props.removeStoreFromFranchiseeUser(
                  this.state.selectedUser.userID,
                  this.state.selectedStore.id
              );
              break;
          case IUserManagementModalSection.TERRITORIES:
              this.props.removeTerritoryFromFranchiseeUser(
                  this.state.selectedUser.userID,
                  this.state.selectedTerritory.id
              );
              break;
          default:
              break;
      }
      this.setAreYouSureVisibility(false);
  };

  private handleUserManagementMapItemModalOkClick = (): void => {
      this.setUserManagementMapItemModalVisiblity(false);
  };
  private handleUserManagementMapItemModalCancelClick = (): void => {
      this.setUserManagementMapItemModalVisiblity(false);
  };

  private setUserManagementModalVisiblity = (visible: boolean): void => {
      this.setState({
          userManagementModalVisible: visible,
      });
  };

  private setUserManagementMapItemModalVisiblity = (visible: boolean): void => {
      this.setState({
          userManagementItemMapModalVisible: visible,
      });
  };

  private setAreYouSureVisibility = (visible: boolean): void => {
      this.setState({
          areYouSureVisible: visible,
      });
  };

  private confirmFranchiseeUserStoreUnassign = (store: IStore): void => {
      this.setSelectedStore(store);
      this.setAreYouSureVisibility(true);
  };

  private confirmFranchiseeUserTerritoryUnassign = (
      territory: ITerritory
  ): void => {
      this.setSelectedTerritory(territory);
      this.setAreYouSureVisibility(true);
  };

  private setSelectedStore = (store: IStore): void => {
      this.setState({
          selectedStore: store,
      });
  };

  private setSelectedTerritory = (territory: ITerritory): void => {
      this.setState({
          selectedTerritory: territory,
      });
  };

  private userSearchInputChanged = (
      event: React.ChangeEvent<HTMLInputElement>
  ): void => {
      const searchTerm: string = event.target.value.toLowerCase();

      if (searchTerm && searchTerm.length > 0) {
          const userCopy: Array<IUser> = [];
          for (let i = 0; i < this.props.allUsers.length; i++) {
              if (
                  this.props.allUsers[i].fullName.toLowerCase().indexOf(searchTerm)
            > -1
          || (this.props.allUsers[i].title
            && this.props.allUsers[i].title.toLowerCase().indexOf(searchTerm) > -1)
              ) {
                  userCopy.push(this.props.allUsers[i]);
              }
          }

          this.setState({
              allUsers: userCopy,
          });
      } else {
          this.setState({
              allUsers: this.props.allUsers,
          });
      }
  };

  private filterChange(pagination, filters, sorter) {
      console.log("params", pagination, filters, sorter);
  }
}

export default UserManagement;
